import { render, staticRenderFns } from "./invoices_detail.vue?vue&type=template&id=28b74d38&scoped=true&"
import script from "./invoices_detail.vue?vue&type=script&lang=js&"
export * from "./invoices_detail.vue?vue&type=script&lang=js&"
import style0 from "./invoices_detail.vue?vue&type=style&index=0&id=28b74d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b74d38",
  null
  
)

export default component.exports